__turbopack_context__.v({
  "buttonLink": "StartMetabolic-module__DFeSKa__buttonLink",
  "container": "StartMetabolic-module__DFeSKa__container",
  "content": "StartMetabolic-module__DFeSKa__content",
  "img": "StartMetabolic-module__DFeSKa__img",
  "title": "StartMetabolic-module__DFeSKa__title",
});
